import { screenStatusTypes } from "./actions.types";

export const setScreenStatus = (status: boolean) => ({
  type: screenStatusTypes.SET_SCREEN_STATUS,
  status,
});
